<template>
  <el-dialog @close="$emit('update:visible', false)" v-bind="$attrs" :title="isEdit ? '编辑数据' : '添加一条数据'"
    class="dialog-800" width="800px">
    <el-form ref="form" :model="form" label-width="150px" v-loading="loading" :rules="rules">
      <el-form-item label="账号" prop="username">
        <el-input v-model="form.username" :maxlength="255" disabled></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="fullName">
        <el-input v-model="form.fullName" :maxlength="255" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="工作单位" prop="workUnit">
        <el-input style="float: left;" :maxlength="255" v-model="form.workUnit" placeholder="请输入工作单位"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="telephone">
        <el-input v-model="form.telephone" :maxlength="12" placeholder="请输入联系电话"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:visible', false)">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">提 交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import UploadFile from "@/components/UploadFile.vue";
import { update as updateApi } from "@/api/individualMember.js";
import EditDialog from "../mixins/EditDialog.js";
import { politicalOutlookList } from "@/utils/index.js";
export default {
  components: { UploadFile },
  mixins: [EditDialog],
  data() {
    return {
      politicalOutlookList,
      yearTurnover: [],
      updateApi,
      active: '1',
      rules:{
        username: [{ required: true, message: "请输入账号"}],
        fullName: [{ required: true, message: "请输入姓名"}],
        telephone: [{ required: true, message: "请输入手机号码"}],
        workUnit: [{ required: true, message: "请输入单位名称"}],
      }
    };
  },
  methods: {
    onSubmit() {
      // 验证表单
      this.$refs["form"].validate((valid, key) => {
        if (valid) {
          // 调用mixins的添加方法
          this.submit()
        } else {
          let errKey = Object.values(key)[0][0];
          this.$message.warning(errKey.message);
          return false;
        }
      })
    }
  }
};
</script>

<style lang="less" scoped></style>